import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {errorMessageStyle} from '../styles';
import ActivityService from "./activity-service";
import AdminService from "./admin-service";

class ActivitySummaryTable extends Component {
    render() {
        const activityRows =
            _.sortBy(_.keys(this.props.activitySummary)).map (resource =>
                <tr>
                    <td>{resource}</td>
                    <td>{this.props.activitySummary[resource]}</td>
                </tr>
            );

        return (<table className="table table-striped small">
            <thead>
            <tr>
                <th>Resource</th>
                <th>Count</th>
            </tr>
            </thead>
            <tbody>
            {activityRows}
            </tbody>
        </table>);
    }
}

ActivitySummaryTable.propTypes = {
    activitySummary: PropTypes.object.isRequired
};

class ActivityDetailsTable extends Component {
    render() {
        const activityRows =
            this.props.activities.map ( a =>
                <tr>
                    <td>{a.timestamp}</td>
                    <td>{a.resource}</td>
                    <td>{a.sourceIP}</td>
                    <td>{a.agent}</td>
                    <td>{a.user}</td>
                </tr>);

        return (
            <table className="table table-striped small">
                <thead>
                <tr>
                    <th>Timestamp</th>
                    <th>Resource</th>
                    <th>Source IP</th>
                    <th>Agent</th>
                    <th>User</th>
                </tr>
                </thead>
                <tbody>
                {activityRows}
                </tbody>
            </table>
        )
    }
}

ActivityDetailsTable.propTypes = {
    activities: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default class ActivityConsole extends Component {
    constructor(props) {
        super(props);
        this.activityService = ActivityService;
        this.adminService = AdminService;
        this.state = {
            isLoading: true,
            errorMessage: '',
            activities: [],
            activitySummary: {},
            fromDate: moment(),
            toDate: moment(),
            users: [],
            user: 'All',
            showDetails: false
        }
    }

    componentDidMount() {
        this.refreshData(this.state.fromDate, this.state.toDate, this.state.user, this.state.showDetails);
        this.adminService.listUsers()
            .done(users => this.setState({users: users}))
            .fail(e => this.setState({errorMessage: e.responseText}));
    }

    refreshData = (fromDate, toDate, user, showDetails) => {
        this.setState({isLoading: true});
        if (showDetails) {
            this.activityService.listActivities(fromDate, toDate, user)
                .done(activities => this.setState({activities: activities}))
                .fail(e => this.setState({errorMessage: e.responseText}))
                .always(() => this.setState({isLoading: false}));
        } else {
            this.activityService.activitySummary(fromDate, toDate, user)
                .done(activitySummary => this.setState({activitySummary: activitySummary}))
                .fail(e => this.setState({errorMessage: e.responseText}))
                .always(() => this.setState({isLoading: false}));
        }
    };

    render() {
        const loadingSpinner = this.state.isLoading ? <span className="spinner"></span> : undefined;

        const errorMessage = this.state.errorMessage ?
            <div className="alert alert-danger" style={errorMessageStyle}>{this.state.errorMessage}</div>
            : undefined;

        return (
            <div>
                {errorMessage}
                <div style={{marginBottom: '5px', fontSize: 'x-small'}}>
                    <form className="form-inline">
                        <label htmlFor="fromDate" style={{marginRight: '5px'}}>From</label>
                        <DatePicker
                            id="fromDate"
                            selected={this.state.fromDate}
                            selectsStart
                            startDate={this.state.fromDate}
                            endDate={this.state.toDate}
                            dateFormat="YYYY-MM-DD"
                            dropdownMode="select"
                            maxDate={moment()}
                            onChange={dt => {this.setState({fromDate: dt}); this.refreshData(dt, this.state.toDate, this.state.user, this.state.showDetails)}}/>

                        <label htmlFor="toDate" style={{marginLeft: '20px', marginRight: '5px'}}>To</label>
                        <DatePicker
                            id="toDate"
                            selected={this.state.toDate}
                            selectsEnd
                            startDate={this.state.fromDate}
                            endDate={this.state.toDate}
                            dateFormat="YYYY-MM-DD"
                            dropdownMode="select"
                            maxDate={moment()}
                            onChange={dt => {this.setState({toDate: dt}); this.refreshData(this.state.fromDate, dt, this.state.user, this.state.showDetails)}}/>

                        <label htmlFor="users" style={{marginLeft: '20px', marginRight: '5px'}}>User:</label>
                        <select id="users" value={this.state.user} onChange={u => {this.setState({user: u.target.value}); this.refreshData(this.state.fromDate, this.state.toDate, u.target.value, this.state.showDetails)}}>
                            <option value="All">All</option>
                            {this.state.users.map(u => <option value={u.id}>{u.email}</option>)}
                        </select>
                        <input type="checkbox"
                               style={{marginLeft: '20px', marginRight: '5px'}}
                               checked={this.state.showDetails}
                               onChange={e => {this.setState({showDetails: e.target.checked}); this.refreshData(this.state.fromDate, this.state.toDate, this.state.user, e.target.checked)}}/>
                        <span>Show details</span>
                    </form>
                    <div className="pull-right">{loadingSpinner}</div>
                </div>
                {this.state.showDetails
                    ? <ActivityDetailsTable activities={this.state.activities}/>
                    : <ActivitySummaryTable activitySummary={this.state.activitySummary}/>}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/admin/activity-console.js